import { createSlice } from "@reduxjs/toolkit";
import {  createFollowup  , getFollowupHistory } from "../../builders/inquiry/followup.builder";
const initialState = {
  followupHistory: [],
  formEditId : null,
  loading : false,
  newFollowupId : null
};

const followupSlice = createSlice({
  name: "followup",
  initialState,
  reducers: {
    setFormEditId : (state, action) => {
      state.formEditId =  action.payload
    },
    setFollowupId : (state, action) => {
      state.newFollowupId = action.payload
    },
    clearExtraReducers : (state) => {
      state.followupTableData = [],
      state.formEditId = null,
      state.loading = false,
      state.newFollowupId = null
  } 
  },
  extraReducers: (builder) => {
    builder.addCase(createFollowup.pending, (state) => {
      state.loading = true
    });
    builder.addCase(createFollowup.fulfilled, (state) => {
      state.loading = false

    });
    builder.addCase(createFollowup.rejected, (state) => {
      state.loading = false
    });
    builder.addCase(getFollowupHistory.pending, (state) => {
      state.loading = true
    });
    builder.addCase(getFollowupHistory.fulfilled, (state, action) => {
        state.followupHistory = action.payload 
      state.loading = false
    });
    builder.addCase(getFollowupHistory.rejected, (state) => {
      state.loading = false
    });
  },
});

export const { setFormEditId , setFollowupId  } = followupSlice.actions;

export default followupSlice .reducer;
